import React from "react";
import qualityIcon from "../../../assets/icons/about4.png";
import developmentIcon from "../../../assets/icons/about5.png"
import guaranteeIcon from "../../../assets/icons/about6.png";
import partnershipsIcon from "../../../assets/icons/about7.png";
import trainingEnvironmentIcon from "../../../assets/icons/about8.png";
import expertLecturersIcon from "../../../assets/icons/about9.png";
import { useTranslation } from "react-i18next";

const Whyivory = () => {
  const { t } = useTranslation();
  return (
    <section className="container">
      {/* Why Ivory? */}
      <div className="two-about">
        <div className=" col-12 two-about-text">
          <h2 className="section-title ">
            {t('about.why')}
          </h2>
        </div>

        <div className="justify-content-between six-cards">
          <FeatureCard
            icon={guaranteeIcon}
            title={t('about.title-3')}
            description={t('about.desc-3')}
          />
          <FeatureCard
            icon={developmentIcon}
            title={t('about.title-4')}
            description={t('about.desc-4')}
          />

          <FeatureCard
            icon={qualityIcon}
            title={t('about.title-5')}
            description={t('about.desc-5')}
          />
          <FeatureCard
            icon={expertLecturersIcon}
            title={t('about.title-6')}
            description={t('about.desc-6')}
          />
          <FeatureCard
            icon={trainingEnvironmentIcon}
            title={t('about.title-7')}
            description={t('about.desc-7')}
          />
          <FeatureCard
            icon={partnershipsIcon}
            title={t('about.title-8')}
            description={t('about.desc-8')}
          />
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ icon, title, description }) => {
  return (
    <div className="feature-card">
      <div>
        <img src={icon} alt={title} />
      </div>
      <p className="text-lg font-semibold !my-2">{title}</p>
      <p className="!px-2">{description}</p>
    </div>
  );
};

export default Whyivory;
